module.exports = __webpack_public_path__ + "img/lang.b51bcc29.svg";